import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const LoanCreationApi = createAsyncThunk(
  'LoanCreationApi',
  async (loanCreationPayload, { dispatch }) => {
    dispatch({ type: 'LoanCreationApi/pending', payload: {} });
    const {
      customerId,
      Authorization,
      customerRefNum,
      otpCode,
      productDetail,
      loanAmount,
      promoCode = '',
    } = loanCreationPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'loanbooking3/loancreationv3',
      payload: {
        customerRefNum,
        loanAmount,
        promoCode,
        otpCode,
        isLowIncomeConsent: true,
        productDetail,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const loanCreationRes = res;
        dispatch({
          type: 'LoanCreationApi/fulfilled',
          payload: loanCreationRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'LoanCreationApi/rejected', payload: err });
      },
    });
  }
);

export const LoanCreationApi_extrareducer = {
  [LoanCreationApi.pending]: (state, action) => {
    state.loanCreationApiState.isLoading = true;
  },
  [LoanCreationApi.fulfilled]: (state, action) => {
    state.loanCreationApiState.isLoading = false;
    state.loanCreationApiState.isSuccess = true;
    state.loanCreationApiState.isError = false;
    state.loanCreationApiState.response = action.payload;
  },
  [LoanCreationApi.rejected]: (state, action) => {
    state.loanCreationApiState.isLoading = false;
    state.loanCreationApiState.isSuccess = false;
    state.loanCreationApiState.isError = true;
    state.loanCreationApiState.response = action.payload;
  },
};
